import background from "img/discussaobola_inteiro.png";

function App({
  filters = [],
  title = "",
  url = "",
  publicationDate,
}) {
  // get the teams in the backend;
  return (
    <a
      style={{ backgroundImage: `url(${background})` }}
      className="box flex newsCard"
      href={url}
      target="_blank"
    >
      <div className="newsCard-container">
        <div style={{ display: "flex", flexDirection: "row" }}>
          {filters.map((el, idx) => (
            <span
              style={{
                backgroundColor: "white",
                marginRight: "0.2em",
                borderRadius: "12px",
                marginRight: "12px",
                padding: "4px",
                fontSize: "11px",
              }}
            >
              {el}
            </span>
          ))}
        </div>
        <h2 className="newsCard-title">{title}</h2>
        <p className="newsCard-date">{publicationDate}</p>
      </div>
    </a>
  );
}

export default App;
